var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M516.472 946.04c-35.688 0.32-64.872-28.4-65.16-64.088l-1.104-136.856a64.64 64.64 0 0 1 64.12-65.136c35.672-0.28 64.832 28.408 65.144 64.128l1.08 136.824c0.304 35.688-28.408 64.88-64.08 65.128z",
    fill: "#E5226B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M938.072 979.992l-842.616 6.792c-35.688 0.28-64.88-28.44-65.16-64.096a64.648 64.648 0 0 1 64.12-65.168l842.648-6.784c35.656-0.28 64.816 28.432 65.128 64.128 0.248 35.688-28.4 64.848-64.12 65.128z",
    fill: "#0092D2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.992 650.336c0.384 49.856-39.632 90.592-89.496 91.008L111.2 747.816c-49.856 0.432-90.592-39.704-90.968-89.56L16 134.68c-0.376-49.808 39.664-90.56 89.52-90.96l807.296-6.504c49.856-0.392 90.568 39.696 90.944 89.504l4.232 523.616z",
    fill: "#EF962F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.2 747.816c-49.856 0.432-90.592-39.704-90.968-89.56L16 134.68c-0.376-49.808 39.664-90.56 89.52-90.96l807.296-6.504",
    fill: "#F4A417"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.1870783111d067f2f157b537915d5281.svg";
export { ForwardRef as ReactComponent };